require('../../modules/es6.math.log2');
module.exports = require('../../modules/_core').Math.log2;



//////////////////
// WEBPACK FOOTER
// ../~/core-js/library/fn/math/log2.js
// module id = 1448
// module chunks = 2